<div class="container p-3">

<h2>{{header}}</h2>

<p-treeTable
    [value]="treeNodes"
    [tableStyle]="{ 'min-width': '60rem' }">

    <!-- HEADER -->
    <ng-template pTemplate="header">
        <tr style="background-color: lightgrey;">
            <th style="width:400px;"></th>
            <th>Per</th>
            <th>Uttag</th>
            <!--th>Typ</th-->
        </tr>
    </ng-template>

    <!-- BODY -->
    <ng-template
        pTemplate="body"
        let-rowNode
        let-rowData="rowData">

        <tr [ttRow]="rowNode">

            <!-- NAMN -->
            <td>

                <p-treeTableToggler
                    [rowNode]="rowNode">
                </p-treeTableToggler>


                <!-- ========================= -->
                <!-- ÅR -->
                <!-- ========================= -->

                <ng-container
                    *ngIf="rowData.type === 'year'">

                    <strong>
                        {{ rowData.year }}
                    </strong>

                </ng-container>


                <!-- ========================= -->
                <!-- RAPPORT -->
                <!-- ========================= -->

                <ng-container
                    *ngIf="rowData.type === 'report'">

                    <span>
                        {{ getReportName(rowData) }}
                    </span>

                </ng-container>


                <!-- ========================= -->
                <!-- FIL -->
                <!-- ========================= -->

                <ng-container
                    *ngIf="rowData.type === 'file'">

                    <a
                        href="#"
                        title="Ladda ner"
                        (click)="
                            downloadFile(rowData.fileId, rowData.fileName);
                            $event.preventDefault()
                        ">

                        {{ rowData.fileName }}

                    </a>

                </ng-container>

            </td>


            <!-- PERIOD -->
            <td>

                <ng-container
                    *ngIf="rowData.type === 'report'">

                    {{ rowData.periodDate | date:'yyyy-MM-dd' }}

                </ng-container>

            </td>


            <!-- UTTAG -->
            <td>

                <ng-container
                    *ngIf="rowData.type === 'report'">

                    {{ rowData.withdrawalDate | date:'yyyy-MM-dd' }}

                </ng-container>

            </td>


            <!-- TYP -->
            <!--td>

                <ng-container
                    *ngIf="rowData.type === 'report'">

                    {{ rowData.reportType }}

                </ng-container>

            </td-->

        </tr>

    </ng-template>

</p-treeTable>

</div>